import Translations from '../Translations';
import React from 'react';
import {
    Card,
    Table,
    // Icon,
    Message,
} from 'semantic-ui-react';
import _ from 'lodash';

import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import ModalSelectLeaveBarterOption from '../../components/modal/selectleavebarteroption';
import {formatAmountWithCurrency} from '../../utils/currency';

const LeaveBarterItem = (props) => {

    // console.log('props->', props);

    const {
        id,
        options,
        choice,
        // status,
        isManagerApprovalRequired,
        customWarningMessage,
    } = props.data;

    const priceSign = (choice.price > 0) ? '+' : (choice.price < 0) ? '-' : '';

    const renderWarningMessage = () => {
        if (isManagerApprovalRequired && customWarningMessage && choice.price !== 0) {
            return <Message error>
                {customWarningMessage}
            </Message>;
        }
        return null;
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header><Translations text="selection.leave options" backup={"Leave Options"} /></Card.Header>
            </Card.Content>
            <Card.Content>
                <Table basic="very" unstackable compact singleLine size="small">
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>
                                <ModalSelectLeaveBarterOption 
                                    id={id}
                                    options={options}
                                    choice={choice}
                                    currencyMinorUnit={props.currencyMinorUnit}
                                    currency={props.currency}
                                    disabled={props.disabled}
                                />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Card.Content>
            <Card.Content>
                <b><Translations text="common.total" backup={"Total"} /></b>
                <div style={{float: "right"}}>
                    <b>{formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas(choice.price >= 0 ? choice.price : choice.price * -1, props.currencyMinorUnit), props.currency, priceSign)}</b>
                    {/* <Icon 
                        color={(choice.price > 0) ? "blue" : "red"}
                        name={(choice.price > 0) ? "add circle" : "minus circle"}
                        style={{marginLeft: 5}}
                    /> */}
                </div>
                {renderWarningMessage()}
            </Card.Content>
        </Card>
    );
};

export default LeaveBarterItem;
